import { Avatar, Box, Chip, Drawer, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { useEffect, useState } from "react";
import { BALANCE_RECORD_TYPES, BALANCE_RECORD_TYPE_MAP, DEPARTMENT_MAP, IMG_BASE_URL, PAYMENT_STATUS, PAY_METHOD_MAP, POINT_RECORD_TYPE_MAP, TIEJUN_LEVEL_MAP, USER_LEVEL_MAP, USER_STATUS_MAP } from "src/config/constants";
import { asyncRequest } from "src/services/network";
import UserInfo from "src/components/common/UserInfo";
import SectionHeader from "src/components/section-header/SectionHeader";
import MerchantInfo from "src/components/common/MerchantInfo";

const pointColumns = [
  { field: "id", headerName: "ID", width: 90 },
  // {
  //   field: "orderSN",
  //   headerName: "订单编号",
  //   width: 200,
  // },
  {
    field: "um",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    renderCell: ({ row }) => {
      return row.isMer ? <MerchantInfo {...row.merchant} enablePreview={false} /> : <UserInfo {...row.user} enablePreview={false} />;
    },
  },
  {
    field: "amount",
    headerName: "数额",
    type: "number",
  },
  {
    field: "currentLocked",
    headerName: "当前剩余",
    type: "number",
    sortable: false,
  },
  {
    field: "type",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    // width: 160,
    valueGetter: (value, row) => POINT_RECORD_TYPE_MAP[value],
  },
  {
    field: "detail",
    headerName: "详情",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "createdAt",
    headerName: "时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

const balanceColumns = [
  { field: "id", headerName: "ID", width: 90 },
  // {
  //   field: "orderSN",
  //   headerName: "订单编号",
  //   width: 200,
  // },
  {
    field: "um",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    renderCell: ({ row }) => {
      return row.isMer ? <MerchantInfo {...row.merchant} enablePreview={false} /> : <UserInfo {...row.user} enablePreview={false} />;
    },
  },
  {
    field: "amount",
    headerName: "数额",
    type: "number",
    // width: 150,
  },
  {
    field: "current",
    headerName: "当前剩余",
    type: "number",
    // width: 110,
    sortable: false,
  },
  {
    field: "type",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    // width: 160,
    valueGetter: (value, row) => BALANCE_RECORD_TYPE_MAP[value],
  },
  {
    field: "detail",
    headerName: "详情",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "createdAt",
    headerName: "时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

const deptSalaryColumns = [
  { field: "id", headerName: "ID", width: 90 },
  // {
  //   field: "orderSN",
  //   headerName: "订单编号",
  //   width: 200,
  // },
  {
    field: "um",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    renderCell: ({ row }) => {
      return row.isMer ? <MerchantInfo {...row.merchant} enablePreview={false} /> : <UserInfo {...row.user} enablePreview={false} />;
    },
  },
  {
    field: "amount",
    headerName: "数额",
    type: "number",
    // width: 150,
  },
  {
    field: "current",
    headerName: "当前剩余",
    type: "number",
    // width: 110,
    sortable: false,
  },
  // {
  //   field: "dept",
  //   headerName: "部门",
  //   valueGetter: (value, row) => DEPARTMENT_MAP[value],
  // },
  {
    field: "detail",
    headerName: "详情",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "createdAt",
    headerName: "时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

const tiejunSalaryColumns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "um",
    headerName: "类型",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    renderCell: ({ row }) => {
      return row.isMer ? <MerchantInfo {...row.merchant} enablePreview={false} /> : <UserInfo {...row.user} enablePreview={false} />;
    },
  },
  {
    field: "amount",
    headerName: "数额",
    type: "number",
    // width: 150,
  },
  {
    field: "current",
    headerName: "当前剩余",
    type: "number",
    // width: 110,
    sortable: false,
  },
  // {
  //   field: "dept",
  //   headerName: "部门",
  //   valueGetter: (value, row) => DEPARTMENT_MAP[value],
  // },
  {
    field: "detail",
    headerName: "详情",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    // valueGetter: (value, row) => `${parseFloat(Math.round((value / row.totalPrice) * 100))}%`,
  },
  {
    field: "createdAt",
    headerName: "时间",
    // description: 'This column has a value getter and is not sortable.',
    width: 200,
    valueGetter: (value, row) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
  },
];

export default function PaymentDetailDrawer({ payment, open, onClose }) {
  const [value, setValue] = useState("订单信息");

  const [info, setInfo] = useState({});
  const [orders, setOrders] = useState([]);
  const [pointRecords, setPointRecords] = useState([]);
  const [balanceRecords, setBalanceRecords] = useState([]);
  const [deptSalaryRecords, setDeptSalaryRecords] = useState([]);
  const [tiejunSalaryRecords, setTiejunSalaryRecords] = useState([]);

  const handleChange = (event, newValue) => {
    switch (newValue) {
      case "积分明细":
        getPointRecords();
        break;
      case "消费券明细":
        getBalanceRecords();
        break;
      // case "部门工资明细":
      //   getDeptSalaryRecords();
      //   break;
      // case "铁军工资明细":
      //   getTiejunSalaryRecords();
      //   break;
    }
    setValue(newValue);
  };

  useEffect(() => {
    if (!open) return;
    // getPaymentDetail();
  }, [open]);

  async function getPaymentDetail() {
    const { data } = await asyncRequest({
      method: "get",
      path: `/payment/detail/${payment.orderSN}`,
    });

    setInfo(data);
  }

  async function getPointRecords() {
    const { data } = await asyncRequest({
      path: "/payment/pointList",
      data: {
        orderSN: payment.orderSN,
        page: 0,
        size: 2000,
      },
    });

    setPointRecords(data);
  }

  async function getBalanceRecords() {
    const { data } = await asyncRequest({
      path: "/payment/balanceList",
      data: {
        orderSN: payment.orderSN,
        page: 0,
        size: 2000,
      },
    });

    setBalanceRecords(data);
  }

  async function getDeptSalaryRecords() {
    const { data } = await asyncRequest({
      path: "/finance/deptsalary/list",
      data: {
        orderSN: payment.orderSN,
        page: 0,
        size: 2000,
      },
    });

    setDeptSalaryRecords(data);
  }

  async function getTiejunSalaryRecords() {
    const { data } = await asyncRequest({
      path: "/finance/salary/list",
      data: {
        orderSN: payment.orderSN,
        page: 0,
        size: 2000,
      },
    });

    setTiejunSalaryRecords(data);
  }

  return (
    <>
      {open && (
        <Drawer anchor="right" open onClose={onClose}>
          <Box sx={{ width: 980 }} p={2}>
            {/* <Grid container mt={3}>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>用户</Typography>
                  <UserInfo {...payment.user} />
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>积分</Typography>
                  <Typography>{info.pointsGained || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>总订单数</Typography>
                  <Typography>{info.payedOrders || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>总消费额</Typography>
                  <Typography>{info.totalPayed || 0}</Typography>
                </Stack>
              </Grid>
              <Grid item xs>
                <Stack gap={1} alignItems="center">
                  <Typography>累计获得消费券</Typography>
                  <Typography>{info.totalReleased || 0}</Typography>
                </Stack>
              </Grid>
            </Grid> */}

            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="订单信息" value="订单信息" />
                  <Tab label="积分明细" value="积分明细" />
                  <Tab label="消费券明细" value="消费券明细" />
                  {/* <Tab label="部门工资明细" value="部门工资明细" /> */}
                  {/* <Tab label="铁军工资明细" value="铁军工资明细" /> */}
                </Tabs>
              </Box>

              <Box sx={{ height: 700, width: "100%" }}>
                {value == "订单信息" && (
                  <Stack p={2}>
                    <SectionHeader title="订单信息" />
                    <Grid container py={1} rowGap={1}>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>用户：</Typography>
                          <UserInfo {...payment.user} enablePreview={false} />
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>商户：</Typography>
                          <MerchantInfo {...payment.merchant} enablePreview={false} />
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>订单编号：</Typography>
                          <Typography>{payment.orderSN}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>订单金额：</Typography>
                          <Typography>{payment.totalPrice}</Typography>
                        </Stack>
                      </Grid>
                    </Grid>

                    <Grid container py={1} rowGap={1}>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>抵扣额：</Typography>
                          <Typography>{payment.deductionPrice}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>实付金额：</Typography>
                          <Typography>{payment.payPrice}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>让利金额：</Typography>
                          <Typography>{payment.rangli}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>支付方式：</Typography>
                          <Typography>{PAY_METHOD_MAP[payment.payMethod]}</Typography>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>下单时间：</Typography>
                          <Typography>{moment(payment.createdAt).format("YYYY-MM-DD HH:mm:ss")}</Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack gap={1} alignItems="center" direction="row">
                          <Typography sx={{ width: 80 }}>支付时间：</Typography>
                          <Typography>{moment(payment.payTime).format("YYYY-MM-DD HH:mm:ss")}</Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                )}

                {/* 积分明细 */}
                {value == "积分明细" && (
                  <DataGrid
                    rows={pointRecords}
                    columns={pointColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}

                {/* 余额明细 */}
                {value == "消费券明细" && (
                  <DataGrid
                    rows={balanceRecords}
                    columns={balanceColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}

                {/* 部门工资 */}
                {value == "部门工资明细" && (
                  <DataGrid
                    rows={deptSalaryRecords}
                    columns={deptSalaryColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}

                {/* 余额明细 */}
                {value == "铁军工资明细" && (
                  <DataGrid
                    rows={tiejunSalaryRecords}
                    columns={tiejunSalaryColumns}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10,
                        },
                      },
                    }}
                    disableColumnFilter
                    disableColumnSorting
                    pageSizeOptions={[5]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Drawer>
      )}
    </>
  );
}
